import React from 'react';
import { Alert } from 'react-bootstrap';

export default function alerts(props) {
  return showAlerts(props);
}

const showAlerts = (props) => {
  return ( props.alerts.length > 0 ? props.alerts.map( (alert, key) => {
    return (
      <Alert key={key} variant={alert.type} className={'mt-3'} > 
        {alert.msg} {props.handleClearAlert ? <i onClick={()=> props.handleClearAlert(alert)} className="fas fa-times-circle pointer-cursor btn-close-alert float-right"></i> : ''}
      </Alert>
    );
  } ):'');
}
